<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="search_box search_box_f clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" type="date" placeholder="开始日期" size="mini"></el-date-picker>
                </div>
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="end_time" type="date" placeholder="结束日期" size="mini"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.search.processing_no" placeholder="加工单号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.search.status" multiple collapse-tags placeholder="订单状态">
                    <el-option :value="1" label="未完成"></el-option>
                    <el-option :value="2" label="已完成"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.processing_type" multiple collapse-tags placeholder="加工类型">
                    <el-option :value="1" label="原木到干板"></el-option>
                    <el-option :value="2" label="原木到湿板"></el-option>
                    <el-option :value="3" label="湿板到干板"></el-option>
                </el-select>
                <!-- <el-input class="search_input search_inputBox" v-model="params.search.plant_name" placeholder="加工厂"></el-input> -->
                <el-select class="search_select search_inputBox" v-model="params.search.plant_id" placeholder="加工厂" @visible-change="getPlant">
                    <el-option v-for="(list,index) in plantList" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.creator_id" multiple collapse-tags placeholder="制单人" @visible-change="getCreator">
                    <el-option v-for="(list,index) in creatorList" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="dialogVisible=!dialogVisible;dialogVisibleType=2;">新建加工单</el-button>
                <!-- <el-button class="funcPublicBtn">添加费用</el-button> -->
                <!-- <el-button class="funcPublicBtn">批量修改</el-button> -->
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="processing.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @getTableDelete="getTableDelete" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber" v-if="totalObj.wood_cube||Number(totalObj.wood_cube)==0">原木:{{totalObj.wood_cube}}</div>
                <div class="totalNumber" v-if="totalObj.wet_cube||Number(totalObj.wet_cube)==0">湿板:{{totalObj.wet_cube}}</div>
                <div class="totalNumber" v-if="totalObj.dry_cube||Number(totalObj.dry_cube)==0">干板:{{totalObj.dry_cube}}</div>
                <div class="totalNumber" v-if="totalObj.triangle_total||Number(totalObj.triangle_total)==0">三角料:{{totalObj.triangle_total}}</div>
                <div class="totalNumber" v-if="totalObj.amount||Number(totalObj.amount)==0">费用:{{totalObj.amount}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="processing.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
         <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC no_print eldialogWidth eldialogMach" :modal="false" :title="companyName+'加工单'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogForm dialogFormB" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="加工厂：" prop="salesman_id">
                            <el-select v-model="form_params.plant_id" @visible-change="getSelectList('mach')" :disabled="form_params.status==2">
                                <el-option v-for="list in selectMap.mach" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="加工日期：" prop="processing_time">
                            <el-date-picker v-model="processing_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                         <el-form-item  label="加工类型：" prop="sales_time">
                            <el-select v-model="form_params.processing_type" :disabled="dialogVisibleType==3||form_params.status==1">
                                <el-option :value="1" label="原木到干板"></el-option>
                                <el-option :value="2" label="原木到湿板"></el-option>
                                <el-option :value="3" label="湿板到干板"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox elFormBoxBtnList elDialogElFormBoxCheckbox" v-if="form_params.processing_type==1||form_params.processing_type==2">
                        <el-form-item  label="锯板单价：" prop="order_lock_level_id">
                            <el-input v-model="form_params.cut_price" :readonly="form_params.status==2"></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox elDialogElFormBoxCheckbox" v-if="form_params.processing_type==1||form_params.processing_type==3">      
                        <el-form-item label="烘干单价：">
                            <el-input v-model="form_params.drying_price" :readonly="form_params.status==2"></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox elDialogElFormBoxCheckbox" v-if="form_params.processing_type==1||form_params.processing_type==2">      
                        <el-form-item label="薄板单价：">
                            <el-input v-model="form_params.thin_price" :readonly="form_params.status==2"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogFlow">
                    <div class="textBox">
                        <div class="requirment">
                            <textarea class="requirmentTextarea" :readonly="form_params.status==2" placeholder="加工要求" v-model="form_params.processing_notice" cols="5"></textarea>
                        </div>
                        <div class="remarkBox">
                            <textarea class="remarkTextarea" :readonly="form_params.status==2" v-model="form_params.remark" cols="5"></textarea>
                        </div>
                    </div>
                    <div class="editBox" v-if="form_params.processing_type==1||form_params.processing_type==2">
                        <div class="editList">
                            <div class="titleBox clearfix">
                                <div class="titleName" style="font-weight:600;">原料明细</div>
                                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="(!form_params.id||form_params.status==1)&&form_params.isHide==0" @click="dialogVisibleMach=!dialogVisibleMach">选择原料</el-button>
                                <el-button class="funcPublicBtn" v-if="(!form_params.id||form_params.status==1)&&form_params.isHide==0" @click="batchDelList">批量删除</el-button>
                                <!-- <div class="titleClick" style="font-weight:600;" v-if="!form_params.id||form_params.status==1" @click="dialogVisibleMach=!dialogVisibleMach">选择原料</div> -->
                            </div>
                            <el-table :data="listDetail" ref="listDetailTable" border stripe highlight-current-row @row-click="listDetailToggleSelection" @selection-change="listDetailSelectionChange" size="mini" height="100%">
                                <el-table-column type="selection" width="45"></el-table-column>
                                <el-table-column label="操作"  width="50" v-if="(!form_params.id||form_params.status==1)&&form_params.isHide==0">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="supplier" label="供应商" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="contract_no" label="合同号" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="batch_no" label="批次号" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="bale_no" label="根号" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="ship_no" label="船名" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="breed" label="树种" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="length" label="长度" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="diameter" label="直径" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="cube" label="码单立方" show-overflow-tooltip></el-table-column>
                                <el-table-column width="200" prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="editBox" v-if="form_params.processing_type==3">
                        <div class="editList">
                            <div class="titleBox clearfix">
                                <div class="titleName" style="font-weight:600;">原料明细</div>
                                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="(!form_params.id||form_params.status==1)&&form_params.isHide==0" @click="dialogVisibleMachS=!dialogVisibleMachS">选择原料</el-button>
                                <el-button class="funcPublicBtn" v-if="(!form_params.id||form_params.status==1)&&form_params.isHide==0" @click="batchDelListS">批量删除</el-button>
                                <!-- <div class="titleClick" style="font-weight:600;" v-if="!form_params.id||form_params.status==1" @click="dialogVisibleMachS=!dialogVisibleMachS">选择湿板</div> -->
                            </div>
                            <el-table :data="listDetailS" ref="listDetailSTable" border stripe highlight-current-row @row-click="listDetailSToggleSelection" @selection-change="listDetailSSelectionChange" size="mini" height="100%">
                                <el-table-column type="selection" width="45"></el-table-column>
                                <el-table-column label="操作"  width="50" v-if="(!form_params.id||form_params.status==1)&&form_params.isHide==0">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_delete" @click="listDetailSDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="supplier" label="供应商" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="contract_no" label="合同号" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="batch_no" label="批次号" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="ship_no" label="船名" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="breed" label="品名" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="bale_no" label="捆包号" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="thickness" label="厚度" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="length" label="长度" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="pieces" label="片数" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="layer_number" label="层数" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="width_total" label="总宽度" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="cube" label="码单立方" show-overflow-tooltip></el-table-column>
                                <!-- <el-table-column prop="category" label="板材类型" show-overflow-tooltip></el-table-column> -->
                                <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="editBtnList clearfix">
                    <!-- <div class="editTax clearfix">
                        <div class="editTaxname">税率%</div>
                        <el-input type="text" class="editTaxinput" v-model="form_params.tax_rate"></el-input>
                    </div> -->
                    <div class="dialogTotal" v-if="form_params.processing_type==1||form_params.processing_type==2" style="margin-left:30px;">合计： <span class="totalData">{{listDetail.length}}根</span>  <span class="totalData">{{listDetailCube}}立方</span>  </div>
                    <div class="dialogTotal" v-if="form_params.processing_type==3" style="margin-left:30px;">合计： <span class="totalData">{{listDetailS.length}}件</span> <span class="totalData">{{listDetailSCube}}立方</span> </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn">打印</el-button>
                        <el-button class="funcPublicBtn" v-if="form_params.id" @click="exportExcelBill">导出</el-button>
                        <el-button class="funcPublicBtn" @click="dialogVisible=!dialogVisible">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="save">保存</el-button>
                        <el-button class="funcPublicBtn" v-if="form_params.id&&form_params.status==2" @click="machBack">撤销</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="form_params.id&&form_params.status==1" @click="complete">完成</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <el-dialog v-dialog-drag :visible.sync="dialogVisibleMach" class="eldialog eldialogC no_print" width="1250px" :modal="false" title="选择资源" custom-class="full_dialog">
            <select-mach @cancel="dialogVisibleMach=!dialogVisibleMach" @selectData="selectData" @selectAndOut="selectAndOut"></select-mach>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleMachS" class="eldialog eldialogC no_print" width="1250px" :modal="false" title="选择资源" custom-class="full_dialog">
            <select-mach-s @cancel="dialogVisibleMachS=!dialogVisibleMachS" @selectData="selectDataS" @selectAndOut="selectAndOutS"></select-mach-s>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .eldialogC .dialogFlow{border:0;}
    .textBox{border:1px solid #ccc;border-radius: 3px;}
    .remarkBox{border:0;}
    .editBox .editList{border:0;padding:0;}
    .titleBox{padding:10px 0;position: relative;height:50px;}
    .titleName{font-size: 16px;color:#333;position: absolute;top:50%;left:0;right:0;margin:auto;transform:translateY(-50%);width:65px;}
    .dialogTotal{font-size: 15px;color:#333;float: left;}
    .titleClick{font-size: 13px;color:#b21111;float: left;cursor: pointer;}
    .delWidth{width:10px;height:10px;position: absolute;top:0;right:0;background: url('../../../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
    .addWidth{position: relative; width:32px;height:32px;float:left;background: url('../../../assets/addWidth.png') no-repeat 50% 50%;background-size: 70% 70%;cursor: pointer;}
    .importExecl{width:100%;text-align: center;}
    .importExecl .funcPublicBtn{display: inline;float: none;}
    .sign{width:15px;height:15px;background: url('/icon/lu.png') no-repeat 100% 100%;background-size: 100% 100%;float: right;position: relative;top:4px;}
    .eldialogBack.eldialogC .dialogFlow{height:490px;max-height: unset}
    .eldialogBack .remarkBox{width:1090px;}
    .eldialogBack .remarkBoxT{width:1090px;}

    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .remarkBoxFourText{padding:5px 5px 5px 60px;}
    .remarkBoxFourText:before{content:"退货原因:";}
    .totalData{margin-right:20px;}

    //标签打印 START
    .print{color:#000;}
    .print .printTipBox{background-color: #fff;position: relative;display: inline-block;width:15cm;height:10cm;border-bottom:1px dotted #ccc;}
    .print .tipNameBox{text-align: center;padding-bottom:5px;}
    .print .tipNameBoxB{border-bottom:2px solid #000;}
    .print .tipbale_no{font-size: 70px;font-weight: 600;}
    .print .tipNameA{font-size: 30px;font-weight: 600;}
    .print .tipNameB{font-size: 40px;font-weight: 600;}
    .print .printTipBox .mess{position: relative;padding:8px 0;padding-right:180px;box-sizing: border-box;}
    .print .printTipBox .messB{border-bottom:2px solid #000;padding:25px 0;padding-right:180px;}
    .print .printTipBox .messC{padding:25px 0;padding-right:180px;}
    .print .tipImage{width:165px;height:165px;position: absolute;top:0px;right:10px;bottom:0;margin:auto;}
    /* .print .tipDetail{} */
    .print .detail{min-width: 40%; height:25px;text-align: left;font-size: 21px;margin-bottom:10px;padding-left:10px;box-sizing: border-box;}
    .print .detail .detailContent{font-weight: 600;}
    .print .tipDetailA .detail{margin-bottom:25px;float: left;}
    .print .tipDetailB .detail{float:left;}
    .print .tipDetailB .detailA{width:100%;}
    .print .tipDetail .detail:last-child{margin-bottom:0;}
    .printBottomCB{text-align: right;padding:0 10px;margin-top:5px;}
    .printBottomCB .printBottom{display: inline-block;text-align: left;}
    .printBottomCB .bottomMess{font-size: 12px;padding:1px 0;}
    .printBottomCF{padding:0 10px;margin-top:5px;font-size: 12px;text-align: left;}
    //标签打印 END
</style>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                dialogVisible:false,
                dialogVisibleType:2,//2新增 3修改
                dialogVisibleMach:false,
                dialogVisibleMachS:false,
                companyName:localStorage.dw_erp_company_name,
                isShowMore:false,
                ispost:true,
                isHidePer:false,
                listDetailCube:0,
                listDetailSCube:0,
                listDetail:[
                    // {
                    //     inventory_id:"",
                    //     inventory:"",
                    //     supplier_id:"",
                    //     supplier:"",
                    //     contract_no:"",
                    //     batch_no:"",
                    //     ship_no:"",
                    //     breed_id:"",
                    //     breed:"",
                    //     length:"",
                    //     diameter:"",
                    //     cube:"",
                    //     remark:""
                    // }
                ],
                listDetailS:[
                    // {
                    //     inventory_id:"",
                    //     supplier_id:"",
                    //     contract_no:"",
                    //     batch_no:"",
                    //     ship_no:"",
                    //     breed_id:"",
                    //     breed:"",
                    //     brand_id:"",
                    //     brand:"",
                    //     bale_no:"",
                    //     thickness:"",
                    //     length:"",
                    //     pieces:"",
                    //     layer_number:"",
                    //     width_total:"",
                    //     width:"",
                    //     cube:"",
                    //     kiln_no:"",
                    //     kiln_in_time:"",
                    //     expected_kiln_time:"",
                    //     category:"",
                    //     remark:""
                    // }
                ],
                start_time:"",
                end_time:"",
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        processing_no:"",
                        plant_name:"",
                        plant_id:"",
                        creator_id:"",
                        processing_type:"",
                        status:"",
                    },
                    page:1,
                    per_page:50
                },
                processing_time:new Date(),
                form_params:{
                    id:"",
                    plant_id:"",
                    processing_time:"",
                    processing_type:1,
                    cut_price:"",
                    drying_price:"",
                    thin_price:"",
                    processing_notice:"",
                    status:"",
                    remark:"",
                    isHide:0,
                    detail_list:""
                },
                last_page:1,
                total:0,
                selectRow:[],
                categoryList:[],
                selectMap:{
                    port:[],
                    warehouse:[],
                    supplier:[],
                    breed:[],
                    brand:[],
                    grade:[],
                    creater:[],
                    mach:[]
                },
                list:[],
                tableCol:[	
                    {colName:"加工日期",colKey:"processing_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"加工类型",colKey:"processing_type_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"加工单号",colKey:"processing_no",colWidth:170,isSetWidth:true,isCanClick:true,isShow:true},
                    {colName:"订单状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isArray:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"原木方数",colKey:"wood_cube_list",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isArray:true},
                    // {colName:"原木根数",colKey:"wood_count",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"湿材批次",colKey:"wet_wood_batch",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isArray:true},
                    {colName:"湿材方数",colKey:"wet_wood_cube_list",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isArray:true},
                    {colName:"干材批次",colKey:"dry_wood_batch",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isArray:true},
                    {colName:"干材件数",colKey:"dry_wood_count_list",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isArray:true},
                    {colName:"干材方数",colKey:"dry_wood_cube_list",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isArray:true},
                    {colName:"加工厂名称",colKey:"plant_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"总计加工费",colKey:"processing_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"成材率",colKey:"outturn_rate",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"缩水率",colKey:"shrink_rate",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"三角料(吨/包)",colKey:"triangle_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"成本价",colKey:"cost_price",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"加工时长",colKey:"processing_duration",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"烘干单价",colKey:"drying_price",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"薄板单价",colKey:"thin_price",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                totalObj:{},
                filterDialogVisible:false,
                filter:"",
                fields:"",
                new_inventory_id:"",
                plantList:[],
                creatorList:[],
                selectRowList:[],
                selectRowListS:[]
            }
        },
        created(){
            this.postFunc("/erp/purchase.category",{},res=>{
                this.categoryList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            this.getSelectList("mach")
        },
        methods:{
            batchDelList(){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let arr = new Array();
                    this.listDetail.forEach(item=>{
                        let flag = true;
                        this.selectRowList.forEach(list=>{
                            if(item.inventory_id==list.inventory_id){
                                flag = false;
                            }
                        })
                        flag?arr.push(JSON.parse(JSON.stringify(item))):""
                        this.listDetail = arr;
                    })
                    let totalCube = 0;
                    this.listDetail.forEach(item=>{
                        totalCube+=Number(item.cube)
                    })
                    this.listDetailCube = this.keepLimit(totalCube)
                }).catch(()=>{});
            },
            batchDelListS(){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // for (let i = this.listDetailS.length - 1; i >= 0; i--) {
                    //     for (let j = this.selectRowListS.length - 1; j >= 0;j--) {
                    //         if(this.listDetailS[i].inventory_id==this.selectRowListS[j].inventory_id){
                    //             this.listDetailS.splice(i, 1);
                    //         }
                    //     }
                    // }
                    let arr = new Array();
                    this.listDetailS.forEach(item=>{
                        let flag = true;
                        this.selectRowListS.forEach(list=>{
                            if(item.inventory_id==list.inventory_id){
                                flag = false;
                            }
                        })
                        flag?arr.push(JSON.parse(JSON.stringify(item))):""
                    })
                    this.listDetailS = arr;
                    let totalCube = 0;
                    this.listDetailS.forEach(item=>{
                        totalCube+=Number(item.cube)
                    })
                    this.listDetailSCube = this.keepLimit(totalCube)
                }).catch(()=>{});
            },
            listDetailToggleSelection(row){
                this.$refs.listDetailTable.toggleRowSelection(row);
            },
            listDetailSToggleSelection(row){
                this.$refs.listDetailSTable.toggleRowSelection(row);
            },
            listDetailSelectionChange(row){
                this.selectRowList = row;
            },
            listDetailSSelectionChange(row){
                this.selectRowListS = row;
            },
            getPlant(){
                this.postFunc("/erp/processing.plants",{},res=>{
                    this.plantList=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getCreator(){
                this.postFunc("/erp/processing.creators",{},res=>{
                    this.creatorList=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            complete(){
                this.$confirm('是否确认完成?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/processing.finish",{id:this.form_params.id},()=>{
                        this.tip("操作成功","success")
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            machBack(){
                this.$confirm('是否确认撤销?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/processing.finish.cancel",{id:this.form_params.id},()=>{
                        this.tip("撤销成功","success")
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            exportExcelBill(){
                this.$exportExecl("/erp/processing.export","加工单",{id:this.form_params.id})
            },
            save(){
                this.$confirm('是否确认保存?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let url = "";
                    this.dialogVisibleType==2?url="/erp/processing.create":url="/erp/processing.update"
                    this.form_params.processing_time = this.formatTimeZero(this.processing_time)
                    this.form_params.detail_list = this.form_params.processing_type==3?this.listDetailS:this.listDetail;
                    this.postFuncLoading(url,this.form_params,()=>{
                        this.tip("保存成功","success")
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            listDetailDelete(index){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {     
                    this.listDetail.splice(index,1)
                    let totalCube = 0;
                    this.listDetail.forEach(item=>{
                        totalCube+=Number(item.cube)
                    })
                    this.listDetailCube = this.keepLimit(totalCube)
                    // if(this.listDetail.length<=0){
                    //     this.listDetail.push({inventory_id:"",inventory:"",supplier_id:"",supplier:"",contract_no:"",batch_no:"",ship_no:"",breed_id:"",breed:"",length:"",diameter:"",cube:"",remark:""})
                    // }
                }).catch(()=>{});
            },
            listDetailSDelete(index){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.listDetailS.splice(index,1)
                    let totalCube = 0;
                    this.listDetailS.forEach(item=>{
                        totalCube+=Number(item.cube)
                    })
                    this.listDetailSCube = this.keepLimit(totalCube)
                    // if(this.listDetailS.length<=0){
                    //     this.listDetailS.push({inventory_id:"",supplier_id:"",contract_no:"",batch_no:"",ship_no:"",breed_id:"",breed:"",brand_id:"",brand:"",bale_no:"",thickness:"",length:"",pieces:"",layer_number:"",width_total:"",width:"",cube:"",kiln_no:"",kiln_in_time:"",expected_kiln_time:"",category:"",remark:""})
                    // }
                }).catch(()=>{});
            },
            selectData(row){
                let rowData = JSON.parse(JSON.stringify(row))
                this.listDetailSet(rowData)
            },
            selectAndOut(row){
                let rowData = JSON.parse(JSON.stringify(row))
                this.listDetailSet(rowData)
                this.dialogVisibleMach = !this.dialogVisibleMach;
            },
            listDetailSet(row){
                let rows=JSON.parse(JSON.stringify(row));
                rows.forEach(item=>{
                    item.inventory_id=item.id;
                    item.id="";
                })
                if(this.listDetail.length==1){
                    if(this.listDetail[0].inventory_id==""){
                        this.listDetail=rows;
                        return;
                    }
                }
                this.listDetail=this.listDetail.concat(rows)
                let result = [];
                let obj = {};
                let data=JSON.parse(JSON.stringify(this.listDetail))
                for(var i =0; i<data.length; i++){
                    if(!obj[data[i].inventory_id]){
                        result.push(data[i]);
                        obj[data[i].inventory_id] = true;
                    }
                }
                this.listDetail=result;
                let totalCube = 0;
                this.listDetail.forEach(item=>{
                    totalCube+=Number(item.cube)
                })
                this.listDetailCube = this.keepLimit(totalCube)
            },
            selectDataS(row){
                let rowData = JSON.parse(JSON.stringify(row))
                this.listDetailSetS(rowData)
            },
            selectAndOutS(row){
                let rowData = JSON.parse(JSON.stringify(row))
                this.listDetailSetS(rowData)
                this.dialogVisibleMachS = !this.dialogVisibleMachS;
            },
            listDetailSetS(row){
                let rows=JSON.parse(JSON.stringify(row));
                rows.forEach(item=>{
                    item.inventory_id=item.id;
                    item.id="";
                })
                if(this.listDetailS.length==1){
                    if(this.listDetailS[0].inventory_id==""){
                        this.listDetailS=rows;
                        return;
                    }
                }
                this.listDetailS=this.listDetailS.concat(rows)
                let result = [];
                let obj = {};
                let data=JSON.parse(JSON.stringify(this.listDetailS))
                for(var i =0; i<data.length; i++){
                    if(!obj[data[i].inventory_id]){
                        result.push(data[i]);
                        obj[data[i].inventory_id] = true;
                    }
                }
                this.listDetailS=result;
                let totalCube = 0;
                this.listDetailS.forEach(item=>{
                    totalCube+=Number(item.cube)
                })
                this.listDetailSCube = this.keepLimit(totalCube)
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getTableEdit(id){
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.form_params = JSON.parse(JSON.stringify(item))
                        this.dialogVisible = true;
                        this.dialogVisibleType = 3;
                        if(this.form_params.processing_type==1||this.form_params.processing_type==2){
                            this.listDetail = this.form_params.detail_list;
                            let totalCube = 0;
                            this.listDetail.forEach(item=>{
                                item.diameter = this.keepLimit(item.diameter)
                                item.length = this.keepLimit(item.length)
                                item.cube = this.keepLimit(item.cube)
                                totalCube+=Number(item.cube)
                            })
                            this.listDetailCube = this.keepLimit(totalCube)
                        }else{
                            this.listDetailS = this.form_params.detail_list;
                            // this.listDetailS.forEach(item=>{
                            //     item.cube = this.keepLimit(item.cube)
                            // })
                            let totalCube = 0;
                            this.listDetailS.forEach(item=>{
                                totalCube+=Number(item.cube)
                            })
                            this.listDetailSCube = this.keepLimit(totalCube)
                        }
                        this.processing_time = this.form_params.processing_time;
                        // this.postFunc("/erp/processing.details",{id:id},res=>{
                        //     this.pl(res)
                        //     this.dialogVisible = true;
                        //     this.dialogVisibleType = 3;
                        //     this.form_params = res.data.data;
                        //     this.processing_time = (res.data.data.processing_time)*1000;
                        //     if(res.data.data.processing_type==1){
                        //         this.listDetail = res.data.data.wood_list;
                        //     }else{
                        //         this.listDetailS = res.data.data.wood_list;
                        //     }
                        // },error=>{
                        //     this.tip(error.data.message,"warning")
                        // })
                    }
                })
            },
            reset(){
                this.start_time=null;
                this.end_time=null;
                this.params={search:{start_time:"",end_time:"",processing_no:"",plant_name:"",creator_id:"",processing_type:"",status:"",},page:1,per_page:50}
                // this.params.status=2;
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time = this.start_time;
                this.params.search.end_time = this.end_time;
                this.params.search.start_time=this.formatTimeZero(this.params.search.start_time);
                this.params.search.end_time=this.formatTimeZero(this.params.search.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/processing.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data .total);
                    this.list=res.data.data.data;
                    this.totalObj=res.data.data.statistics;
                    this.list.forEach((item,index)=>{
                        this.list[index].processing_time = this.formatTime(item.processing_time*1000)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            del(ids){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/processing.delete",{ids:ids},()=>{
                        this.tip("删除成功","success")
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="processing_no"){
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_ID")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_MACHINDETAIL_ID",obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '加工单流程详情'+obj.id,
                        label: '加工单流程详情',
                        content: 'machiningFakeDetail'
                    });
                }
            },
            getTableDelete(id){
                this.del([id])
            },
            
            getRow(row){
                this.selectRow=row;
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.form_params = this.resetJson(this.form_params);
                    this.form_params.processing_type = 1;
                    this.form_params.processing_time = new Date();
                    this.form_params.plant_id = this.selectMap.mach.length>1?this.form_params.plant_id = this.selectMap.mach[0].id : "";
                    this.form_params.isHide = 0;
                    this.listDetailS = [];
                    this.listDetail = [];
                    this.listDetailCube = 0;
                    this.listDetailSCube = 0;
                }else{
                    if(this.form_params.id==""){
                        this.selectMap.mach.length>1?this.form_params.plant_id = this.selectMap.mach[0].id : ""
                    }
                }
            }
        }
    }
</script>
